import React from 'react';
import '../Styles/privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-page-wrapper">
      <div className="privacy-container">

        <h1 className="privacy-title">
          Privacy <span className="privacy-title-highlight">Policy</span>
        </h1>

        <p className="privacy-intro">
          At Vanakkam HRD, we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard the information you provide through our website, events, and services.
        </p>

        <section className="privacy-section">
          <h2 className="privacy-heading">Information We Collect</h2>
          <p className="privacy-text">
            Please read these terms carefully before using the online payment facility. Using the online payment facility on this website indicates that you accept these terms. If you do not accept these terms do not use this facility.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Information We Collect</h2>

          <ul className="privacy-list">
            <li>Name, email address, phone number, and organization details.</li>
            <li>Registration and event participation information.</li>
            <li>Website usage data through cookies and analytics tools.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">How We Use Your Information</h2>

          <ul className="privacy-list">
            <li>Process event registrations and memberships.</li>
            <li>Send event updates, newsletters, and important announcements.</li>
            <li>Improve our website, services, and user experience.</li>
            <li>Respond to inquiries and provide customer support.</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Data Protection</h2>

          <p className="privacy-text">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, loss, misuse, or disclosure.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Information Sharing</h2>

          <p className="privacy-text">
            We do not sell or rent your personal information. We may share your data only with trusted service providers or event partners when necessary to deliver our services or comply with legal obligations.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Cookies</h2>

          <p className="privacy-text">
            Our website may use cookies to enhance user experience, analyze website traffic, and improve website functionality. You can manage cookie preferences through your browser settings.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Your Rights</h2>

          <p className="privacy-text">
            You may request access, correction, or deletion of your personal information by contacting us.
          </p>
        </section>

        <section className="privacy-section">
          <h2 className="privacy-heading">Policy Updates</h2>

          <p className="privacy-text">
            Vanakkam HRD may update this Privacy Policy from time to time. Changes will be posted on this page with the revised effective date.
          </p>
        </section>

        <section className="privacy-section privacy-section-last">
          <h2 className="privacy-heading">Contact Us</h2>

          <p className="privacy-text">
            For any privacy-related questions or requests, please contact us through the contact details provided on our website.
          </p>
        </section>

      </div>
    </div>
  );
};

export default Privacy;